import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../buttons";

export default function WhyUsSection() {
  const { t } = useTranslation();

  return (
    <section className="why-us-section">
      <div className="container">
        <h1 className="size-1 text-bold ws-pw mb-3">
          {t("why")}&nbsp;
          <br className="d-md-block d-none" />
          {t("costs")}&nbsp;
          <br className="d-md-none d-block" />
          {t("choose")}&nbsp;
          <br className="d-md-block d-none" />
          {`${t("us")}?`}
        </h1>
        <div className="row">
          <div className="col-md-4 col-6 left pr-md-0">
            <div className="reason-card">
              <h6 className="size-6 text-bold natural-3 lh-32">
                {t("we_delivery_from_usa")}
              </h6>
              <p className="size-7 text-bold natural-4 lh-24">
                {t("delivery_parcels_7_day")}
              </p>
            </div>
            <div className="reason-card">
              <h6 className="size-6 text-bold natural-3 lh-32">
                {t("fair_and_transparent")}
              </h6>
              <p className="size-7 text-bold natural-4 lh-24">
                {t("logical_and_clear_system")}
              </p>
            </div>
          </div>
          <div className="col-md-4 col-6 middle">
            <div className="reason-card">
              <h6 className="size-6 text-bold natural-3">
                {t("you_always_know")}
              </h6>
              <p className="size-7 text-bold natural-4 lh-24 m-0">
                {t("we_display_delivery")}
              </p>
            </div>
            <div className="reason-card">
              <h6 className="size-6 text-bold natural-3 lh-32">
                {t("customer_support_7_day")}
              </h6>
              <p className="size-7 text-bold natural-4 lh-24 m-0">
                {t("we_are_always_in_touch")}
              </p>
            </div>
          </div>
          <div className="col-md-4 col-12 right pl-md-0">
            <div className="reason-card">
              <h4 className="size-4 text-bold natural-8 lh-32 mb-3 ls-0">
                {t("customer_support_7_day")}
              </h4>
              <p className="size-7 text-bold natural-8 lh-24 m-0">
                {t("we_are_always_in_touch")}
              </p>
              <Button onClick={() => {}} className="more-btn">
                {t("more")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
